// AUTO-EXTRACTED from SourceSecurity.com via Claude Sonnet 4.6 + Playwright MCP
// Generated: 2026-05-16
// Specs parsed from public product spec sheets; no values invented.
// All entries marked verified: false — reviewer must spot-check before promotion.

import type { EquipmentCatalogEntry } from '../equipmentCatalogEntry';

export const SS_PANIC_BUTTONS: EquipmentCatalogEntry[] = [
  {
    id: "ss-dsc-ws4938",
    manufacturer: "DSC",
    model: "- WS4938",
    category: "panic-button",
    tagline: "DSC WS4938 - Single-Button Personal Panic",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-ws4938-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"memory":"momentary","connection":"wired-nc"},
  },
  {
    id: "ss-ajax-starterkit",
    manufacturer: "Ajax",
    model: "StarterKit",
    category: "panic-button",
    tagline: "Ajax StarterKit - Consists of hub, motion detector, opening detector and key fob with panic button",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-starterkit-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"memory":"momentary","connection":"wired-nc"},
  },
];
